import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Modal, Layout, Row, Col, Select } from 'antd'
import _ from 'lodash'
import Detail from './Detail'
@inject((store: any) => {
    const { popupStore, drugsStore, companiesStore } = store
    return { popupStore, drugsStore, companiesStore }
})
@observer
export default class DrugCompaniesPopup extends Component<any, any> {
    componentDidMount() {
        this.loadStaticData()
    }

    loadStaticData = async () => {
        const { companiesStore } = this.props
        await companiesStore.getHMO()
    }

    setFilter = async filters => {
        await this.setState(prevState => ({ ...prevState, ...filters }))
    }
    renderDrugKey = item => {
        let policy_name = item.policy_name ? item.policy_name : ''
        let quantity_id = item.quantity ? item.quantity : ''
        let drug_key = item.company_name ? item.company_name : ''
        if (policy_name != '') {
            drug_key += ' - ' + policy_name
        }
        if (quantity_id != '') {
            drug_key += ' - ' + quantity_id
        }
        return drug_key
    }
    closePopup = () => {
        const { drugsStore } = this.props
        drugsStore.resetFilter_DrugCompanies()
        this.props.popupStore.togglePopup(false)
    }
    render() {
        const { popupStore, drugsStore, companiesStore } = this.props
        const { filters_drugsCompanies, filtered_DrugCompanies } = drugsStore

        return (
            <Modal
                title={'מחירי תרופות בקופות חולים'}
                visible={popupStore.popupType === 'drugsCompanies'}
                cancelText="ביטול"
                onOk={this.closePopup}
                onCancel={this.closePopup}
            >
                <div style={{ paddingBottom: '2rem' }}>
                    <Layout style={{ padding: '0 1rem' }}>
                        <Row style={{ display: 'flex', alignItems: 'center' }}>
                            <Col xs={24} style={{ padding: '0 0.5rem' }}>
                                {/* <strong>סינון לפי קופת חולים</strong> */}
                                <Select
                                    style={{ width: '100%' }}
                                    value={filters_drugsCompanies.company_id}
                                    onChange={e => drugsStore.setFilterDrugsCompanies('company_id', e)}
                                    placeholder="כל קופות החולים"
                                >
                                    <Select.Option value={null}>כל קופות החולים</Select.Option>
                                    {companiesStore.list.map(company => (
                                        <Select.Option key={company.id} value={company.id}>
                                            {company.name}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Col>
                        </Row>
                    </Layout>
                </div>
                {filtered_DrugCompanies &&
                    filtered_DrugCompanies.length > 0 &&
                    filtered_DrugCompanies.map((item, index) => (
                        <Detail key={item.id} drug_key={this.renderDrugKey(item)} drug={item} />
                    ))}
                {filtered_DrugCompanies && filtered_DrugCompanies.length == 0 && (
                    <div>אין שיוך לפוליסות בקופה שנבחרה</div>
                )}
            </Modal>
        )
    }
}
